import { UploaderService } from './uploader.service'
import { ReportFileService } from './report-file.service'

export const uploaderService = new UploaderService()
export const reportFileService = new ReportFileService()
